var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.hasWidthSections ? ("min-width: " + _vm.fullWidth + "px") : null)},[_c('section',{staticClass:"is-sticky",style:(_vm.hasWidthSections ? ("width: " + _vm.wrapperWidth + "px") : null)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }